import { initializeApp } from "firebase/app";
import { getDatabase, ref, set } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyALEbMJg4sLpAyiZqSSO50Pxb3SakPxeVU",
    authDomain: "dompet-f1922.firebaseapp.com",
    databaseURL: "https://dompet-f1922-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "dompet-f1922",
    storageBucket: "dompet-f1922.appspot.com",
    messagingSenderId: "71649602762",
    appId: "1:71649602762:web:ae5689b245dfbcc979d833",
    measurementId: "G-2PWD22WVJ4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firebaseDB = getDatabase(app)

// firebase.initializeApp(firebaseConfig);
// const firebaseDB = firebase.database();

const updateFirebasePencairan = (params, progres) => {
    params.progres = progres
    const id_opd = params.id_opd
    const db = getDatabase();
    set(ref(db, '/pencairan/'), {
        [id_opd]: params
    });
}
const updateFirebasePermintaan = (params, progres) => {
    params.progres = progres
    const db = getDatabase();
    set(ref(db, '/permintaan/'), {
        permintaan: params
    });
}

export { firebaseDB, updateFirebasePencairan, updateFirebasePermintaan }